import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1904779843432668';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
    __fbPixelInitialized?: boolean;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.__fbPixelInitialized) return;
    window.__fbPixelInitialized = true;
    const init = () => {
      try {
        if (window.fbq) {
          try {
            window.fbq('track', 'PageView');
          } catch (_) {}
          return;
        }
        /* eslint-disable */
        ;
        (function (f: any, b: any, e: string, v: string) {
          if (f.fbq) return;
          const n: any = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = true;
          n.version = '2.0';
          n.queue = [];
          const t = b.createElement(e);
          t.async = true;
          t.defer = true;
          t.src = v;
          t.onerror = () => {
            // Silently ignore failures (adblockers, ITP, network issues)
          };
          const s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        /* eslint-enable */
        try {
          window.fbq('init', PIXEL_ID);
          window.fbq('track', 'PageView');
        } catch (_) {}
      } catch (_) {
        // Never let pixel setup break the app
      }
    };
    // Defer to idle time so it never blocks initial render or hydration
    const w: any = window;
    if (typeof w.requestIdleCallback === 'function') {
      w.requestIdleCallback(init, {
        timeout: 2000
      });
    } else {
      setTimeout(init, 300);
    }
  }, []);
  return null;
}